import type { JSX } from 'react'
// import LanguagePicker from './LanguagePicker'
// import ThemeModePicker from './ThemeModePicker'
import NavigationHeader from './NavigationHeader'

const AppHeader = (): JSX.Element => {
  return <NavigationHeader />
}

export default AppHeader
